import React, {useEffect, useRef, useState} from 'react';
import {Button} from "../global/Button";
import {Line} from "../global/Line";

import Typed from "typed.js";
import introImg from "../../images/ecosystem-into.svg";

export const Intro = (props) => {
  const data = props.data;

  const labelRef = useRef(null);

  const [line, setLine] = useState(null);
  const textBlock = useRef(null);

  const typedOptions = {
    showCursor:false,
    typeSpeed: 30,
  };
  let typed = [
    {
      text : data.titlePart0,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart1,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart2,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart3,
      ref : useRef(null),
      suptext : useRef(null),
      typed : useRef(null)
    },
    // {
    //   text : data.titlePart4,
    //   suptext : useRef(null),
    //   ref : useRef(null),
    //   typed : useRef(null)
    // },
  ];
  const LineX = () =>{
    return <Line start={typed[2].ref} end={labelRef} startAnchor={"right"} animateDrawing={0} color={"#ffffff"} />;
  };
  //Typed
  useEffect(() => {
    let nextWordDelay = 0;
    typed.forEach( (item, index) => {
      if(index !== 0){
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed;
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay : nextWordDelay,
        strings: [
          item.text
        ],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('opacity-0')
          if (item?.suptext.current){
            item.suptext.current.classList.remove('opacity-0')
          }
        },
        onComplete: (self) => {
          if(index === typed.length - 1){
            setLine(<LineX />);

            textBlock.current.classList.remove('opacity-0')
            document.querySelector('.zg-ecosystem-intro-img')?.classList.remove('opacity-0')
          }
        },
      });
    })
    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.forEach( (item, index) => {
        item.typed.current.destroy();
      });
    }
  }, []);


  return (
    <section className="pt-14-rem pb-6">
      <div className="container">
        <div className="row">
          <div className="col-10 col-md-10 col-lg-8 position-relative mb-6 mb-md-8 mb-xl-9">
            <h1 className="d-inline-flex flex-wrap align-items-start h2">
              <span className="zg-text-bg bg-pink mb-1 mb-md-2 me-1 me-md-2 opacity-0" ref={typed[0].ref}></span>
              <span className="zg-text-bg bg-green mb-1 mb-md-2 me-1 me-md-2 opacity-0" ref={typed[1].ref}></span>
              <span className="zg-text-bg bg-white mb-1 me-1 me-md-2 mb-md-2 opacity-0" ref={typed[2].ref}></span>
              <span className="zg-text-bg bg-orange mb-1 mb-md-2 opacity-0 position-relative z-1" ref={typed[3].ref}></span>
              {/*<span className="zg-label bg-orange mx-1 mx-md-2 opacity-0" ref={typed[4].suptext}>{data.suptext1}</span>*/}
              {/*<span className="zg-text-bg bg-orange me-2 mb-1 mb-md-2 opacity-0" ref={typed[4].ref}></span>*/}
            </h1>
            <img className="zg-ecosystem-intro-img transition-opacity opacity-0" src={introImg} alt="Globe" width="345" height="344" />
          </div>
        </div>
        <div className="transition-opacity opacity-0" ref={textBlock}>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 col-xl-5 mb-6 mb-md-0 mb-lg-4 order-0 order-lg-0 position-relative z-1">
              <a className='btn-lg btn btn-outline-white' href={data.link.url}>
              {data.link.title}
              </a>
            </div>
            <div className="col-10 col-md-6 col-lg-4 col-xl-4 position-relative order-0 mb-md-6 ">
              <span ref={labelRef} className="zg-label bg-white me-lg-2 mb-2 mb-lg-3">{data.number}</span>
              {data.text && (
                <p className="zg-text-lg mb-0" dangerouslySetInnerHTML={{__html:data.text}}></p>
              )}

            </div>
          </div>
          {line}
        </div>
      </div>
    </section>
  )
}
